import { render, staticRenderFns } from "./DashboardPage_mobile.vue?vue&type=template&id=9895cc02"
import script from "./DashboardPage_mobile.vue?vue&type=script&lang=js"
export * from "./DashboardPage_mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports